var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileStorySocialLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#34A5FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1556ED"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "url(#a)",
  rx: 20
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M31 17.5c0-1.219-1.064-2-2-2h-6.5c.467-.376 1-3.013 1-4s0-2-1-3-3.041-.622-3 .261c.039.831.256 3.618 0 4.441-.301.97-.42 1.296-1 1.974-.699.82-1.5 1.974-2.5 3.948v8.388c.313.31 1 .987 2.5 1.48l8.126-.05S28.916 28.71 29 27.5c0-1.21-.5-1.5-.5-1.5s2-.813 2-2-.5-1.5-.5-1.5 1.5-.186 1.5-1.5c0-.605-.779-1.502-1.5-1.5.47.002 1-1 1-2M10.5 17H12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-1.5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2"
}))));
export default SvgFacebookMobileStorySocialLike;